import { v4 as uuidV4 } from "uuid";

window.sessionStorage.setItem("chat-uuid", uuidV4());
window.sessionStorage.setItem("user-uuid", uuidV4());

export const getChatUuid = () => {
  return window.sessionStorage.getItem("chat-uuid")
}

export const getUserUuid = () => {
  return window.sessionStorage.getItem("user-uuid")
}